import { render, staticRenderFns } from "./promo-news.vue?vue&type=template&id=4f249505"
import script from "./promo-news.vue?vue&type=script&lang=js"
export * from "./promo-news.vue?vue&type=script&lang=js"
import style0 from "./promo-news.vue?vue&type=style&index=0&id=4f249505&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports